import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-16 h-16 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin"></div>
      </div>
    );
  }

  // Check if user has SUPER_ADMIN platform role - check multiple possible fields
  const isPlatformAdmin = user?.platform_role === 'SUPER_ADMIN' ||
                         user?.platform_role === 'ADMIN' ||
                         user?.role === 'ADMIN' ||
                         user?.email === 'admin@aibizbook.com' ||
                         user?.email === 'admin@billsera.com' ||
                         user?.email === 'admin@test.com'; // Admin email whitelist

  if (!user) {
    // Not logged in - redirect to admin login
    return <Navigate to="/admin/login" replace />;
  }

  if (!isPlatformAdmin) {
    // Logged in but not admin - redirect to home
    console.log('RequireAdmin: User is not admin', { user, isPlatformAdmin });
    return <Navigate to="/" replace />;
  }
  
  console.log('RequireAdmin: Access granted', { user, isPlatformAdmin });

  return children;
};

export default RequireAdmin;
